export default __webpack_public_path__ + "static/media/grafema_gim-tonico_14.2892c3ab.jpg";